import React, { ReactElement, CSSProperties } from "react";
import Text from "../Text/Text";
import styles from "./OnboardingCard.module.css";

interface OnboardingCardProps {
  heading: string;
  imgSrc: string;
  paragraphs: Array<string | ReactElement>;
  wrapperStyle?: CSSProperties;
  imgStyle?: CSSProperties;
  headingStyle?: CSSProperties;
  paragraphStyle?: CSSProperties;
}

const OnboardingCard: React.FC<OnboardingCardProps> = ({
  heading,
  imgSrc,
  paragraphs,
  wrapperStyle,
  imgStyle,
  headingStyle,
  paragraphStyle
}): ReactElement => {
  return (
    <div className={styles.wrapper} style={wrapperStyle}>
      <img src={imgSrc} alt={heading} style={imgStyle}/>
      <Text type="header" wrapper="h1" style={{ textAlign: "center", margin: 0, ...headingStyle }}>
        {heading}
      </Text>
      <>
        {paragraphs.map((paragraph, index) => {
          if (React.isValidElement(paragraph)) {
            return paragraph;
          }
          
          return (
            <Text
              key={index}
              type="body"
              wrapper="p"
              style={{ marginTop: index === 0 ? 0 : "1em", textAlign: "center", ...paragraphStyle }}
            >
              {paragraph}
            </Text>
          );
        })}
      </>
    </div>
  );
};

export default OnboardingCard;
